import { Component } from "../../core/Component";
export class HiddenComponent extends Component {
  // static className = "fiels_item";
  constructor($root, options) {
    super($root, options);
    this.fieldId = options.id;
    this.typeId = options.typeId;
    this.label = options.label || "";
    this.hint = options.hint || "";
    this.type = options.type || "hidden";
    this.value = options.value || "";
    /* if(typeof options.classes === "string" && options.classes.length > 0) {
      $root.$el.classList.add(`wrap-${options.classes}`)
    } */
    this.classes = options.classes || "";
    // установка пользовательских классов оформления
    // this.setUserClasses()

    this.wrapClasses = this.makeWrapUserClasses({
      noWrapPrefix: true
    });
    this.name = `${options.name}`;
    this.id = `${options.name}_${options.formIndex}`;
  }
  toHTML() {
    return `
    <input 
      type="${this.type}"
      id="${this.id}"
      name="${this.name}"
      value="${this.value}"
      class="${this.wrapClasses?.join(' ') || ""}"
    >
    `;
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.$input = this.$root.$el.querySelector(`#${this.id}`);
    this.$input.disabled = disable;
    super.init();
  }
  getValue() {
    if (this.$input.value) {
      return {
        id: this.fieldId,
        name: this.name,
        typeId: this.typeId,
        values: [this.$input.value]
      };
    }
  }
  validation() {
    return true;
  }
}